import React, { useEffect, useState, useRef } from "react";
import TimeIcon from "../../../assets/icon/Time.svg";

import "./predictionBox.css";
import teamImage from "../../../utilities/constants.json";
import Moment from "moment";
import { predictGameAnswer } from "../../../services/questionApi";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import { Link } from "react-router-dom";

import "react-toastify/dist/ReactToastify.css";
import PredictionCountDown from "./PredictionCountDown";
import { useUpdateQuestions } from "../../../hooks/useUpdateQuestions";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const imageUrl = teamImage.team_image;

const PredictionBoxInput = (prop) => {
  const [openTimeOut, setOpenTimeOut] = useState(false);
  const [openPleaseLogin, setOpenPleaseLogin] = useState(false);

  const { updateQuestions } = useUpdateQuestions();

  const fixtureUrl = prop?.data?.fixture?.fix_url;

  const handleTimeOutClose = () => {
    setOpenTimeOut(false);
  };

  const handlePleaseLoginClose = () => {
    setOpenPleaseLogin(false);
  };

  const index = parseInt(prop.index) + 1;

  const [userPrediction, setUserPrediction] = useState();

  const [answer, setAnswer] = useState(null);
  const [answer1, setAnswer1] = useState(null);
  const [answer2, setAnswer2] = useState(null);
  const [timeFlag, setTimeFlag] = useState(false);

  const time = React.useMemo(
    () =>
      new Date(
        Moment(prop?.data?.que_time_qatar_string, "YYYY-MM-DD HH:mm:ss").format(
          "MMM DD, YYYY HH:mm:ss",
        ),
      ).getTime(),
    [prop?.data?.que_time_qatar_string],
  );

  let currentDate = Moment.utc()
    .utcOffset(teamImage.timeOffset)
    .format("YYYY-MM-DD HH:mm:ss");

  useEffect(() => {
    setTimeFlag(false);
    setUserPrediction("");
    setDefaultData();
  }, [prop?.data?._id?.$oid, prop?.data?.user_prediction?.answer]);

  function setDefaultData() {
    if (prop.type == 1) {
      setAnswer(prop.data.que_answer);
    } else if (prop.type == 2) {
      if (prop.data.que_answer) {
        let splitAnswer = prop.data.que_answer.split(",");
        setAnswer1(splitAnswer[0]);
        setAnswer2(splitAnswer[1]);
      }
    }
    if (prop.data.user_prediction) {
      var panswer = "";
      if (prop.type == 2) {
        let userAns = prop.data.user_prediction.answer;
        let splitans = userAns.split(",");
        panswer = splitans[0] + " - " + splitans[1];
        if (!prop.data.que_answer) {
          setAnswer1(splitans[0]);
          setAnswer2(splitans[1]);
        }
      } else {
        panswer = prop.data.user_prediction.answer;
        setAnswer(panswer);
      }
      setUserPrediction(panswer);
    } else {
      if (!prop.data.que_answer) {
        setUserPrediction("");
        setAnswer("");
        setAnswer1("");
        setAnswer2("");
      }
    }
    let stime = new Date(
      Moment(prop.data.que_time_qatar_string, "YYYY-MM-DD HH:mm:ss").format(
        "MMM DD, YYYY HH:mm:ss",
      ),
    ).getTime();
    if (stime < new Date(Date.parse(currentDate)).getTime()) {
      setTimeFlag(true);
    }
  }

  function handleClick() {
    if (!localStorage.webKey) {
      setOpenPleaseLogin(true);
      return;
    }

    let currentDate = Moment.utc()
      .utcOffset(teamImage.timeOffset)
      .format("YYYY-MM-DDTHH:mm:ss");

    if (time <= new Date(currentDate).getTime()) {
      setOpenTimeOut(true);
    }
  }

  function markAnswer(text) {
    const value = text.replace(/[^0-9]/g, "");
    if (localStorage.webKey) {
      let currentDate = Moment.utc()
        .utcOffset(teamImage.timeOffset)
        .format("YYYY-MM-DDTHH:mm:ss");

      if (time > new Date(Date.parse(currentDate)).getTime()) {
        setAnswer(value);
        const isAnswerValid = !isNaN(value) && Number(value) >= 0;
        if (isAnswerValid) {
          value === ""
            ? prop.updateAnswers(
                {
                  fixture_id: prop.data.fixture._id["$oid"],
                  question_id: prop.data._id["$oid"],
                  answer: value,
                },
                true,
              )
            : prop.updateAnswers({
                fixture_id: prop.data.fixture._id["$oid"],
                question_id: prop.data._id["$oid"],
                answer: value,
              });
        }
      } else {
        setAnswer("");

        setOpenTimeOut(true);
      }
    } else {
      setAnswer("");
      setOpenPleaseLogin(true);
    }
  }
  function markAnswer1(text) {
    const value = text.replace(/[^0-9]/g, "");
    if (localStorage.webKey) {
      let currentDate = Moment.utc()
        .utcOffset(teamImage.timeOffset)
        .format("YYYY-MM-DDTHH:mm:ss");
      if (
        new Date(time).getTime() > new Date(Date.parse(currentDate)).getTime()
      ) {
        setAnswer1(value);
        const isAnswer1Valid = !isNaN(value) && Number(value) >= 0;
        const isAnswer2Valid = !isNaN(answer2) && Number(answer2) >= 0;
        if (isAnswer1Valid && isAnswer2Valid) {
          if (value !== "" && answer2 !== "") {
            prop.updateAnswers({
              fixture_id: prop.data.fixture._id["$oid"],
              question_id: prop.data._id["$oid"],
              answer: value + "," + answer2,
            });
          } else
            prop.updateAnswers(
              {
                fixture_id: prop.data.fixture._id["$oid"],
                question_id: prop.data._id["$oid"],
                answer: value + "," + answer2,
              },
              true,
            );
        }
      } else {
        setAnswer1("");

        setOpenTimeOut(true);
      }
    } else {
      setAnswer1("");
      setOpenPleaseLogin(true);
    }
  }
  function markAnswer2(text) {
    const value = text.replace(/[^0-9]/g, "");
    if (localStorage.webKey) {
      let currentDate = Moment.utc()
        .utcOffset(teamImage.timeOffset)
        .format("YYYY-MM-DDTHH:mm:ss");
      if (
        new Date(time).getTime() > new Date(Date.parse(currentDate)).getTime()
      ) {
        setAnswer2(value);
        const isAnswer1Valid = !isNaN(answer1) && Number(answer1) >= 0;
        const isAnswer2Valid = !isNaN(value) && Number(value) >= 0;
        if (isAnswer1Valid && isAnswer2Valid) {
          if (answer1 !== "" && value !== "") {
            prop.updateAnswers({
              fixture_id: prop.data.fixture._id["$oid"],
              question_id: prop.data._id["$oid"],
              answer: answer1 + "," + value,
            });
          } else
            prop.updateAnswers(
              {
                fixture_id: prop.data.fixture._id["$oid"],
                question_id: prop.data._id["$oid"],
                answer: answer1 + "," + value,
              },
              true,
            );
        }
      } else {
        setAnswer2("");
        setOpenTimeOut(true);
      }
    } else {
      setAnswer2("");
      setOpenPleaseLogin(true);
    }
  }

  function predictAnswer() {
    if (localStorage.webKey) {
      let currentDate = Moment.utc()
        .utcOffset(teamImage.timeOffset)
        .format("YYYY-MM-DDTHH:mm:ss");
      if (new Date(time).getTime() > new Date(currentDate).getTime()) {
        let markAnswer = "";
        let flag = 0;
        if (prop.type == 2 && answer1 && answer2) {
          markAnswer = answer1 + "," + answer2;
        } else if (prop.type == 2) {
          flag = 1;
          setAnswer1("");
          setAnswer2("");
          alert("Please fill");
        }

        if (flag == 0 && prop.type == 2) {
          predictGameAnswer({
            question_id: prop.data._id["$oid"],
            fixture_id: prop.data.fixture._id["$oid"],
            answer: markAnswer,
          })
            .then((res) => {
              if (res.data.status == 1) {
                setUserPrediction(answer1 + " - " + answer2);
                updateQuestions(prop.data._id["$oid"], markAnswer);
              } else {
                if (res.data.status == 101) {
                  localStorage.clear();
                  setOpenPleaseLogin(true);
                } else {
                  if (res.data.message == "Time out!") {
                    setOpenTimeOut(true);
                  }
                }
              }
            })
            .catch(() => {});
        } else if (prop.type == 1) {
          predictGameAnswer({
            question_id: prop.data._id["$oid"],
            fixture_id: prop.data.fixture._id["$oid"],
            answer: answer.toString(),
          })
            .then((res) => {
              if (res.data.status == 1) {
                updateQuestions(prop.data._id["$oid"], answer);
                setUserPrediction(answer);
              } else {
                if (res.data.status == 101) {
                  localStorage.clear();
                  setOpenPleaseLogin(true);
                } else {
                  if (res.data.message == "Time out!") {
                    setOpenTimeOut(true);
                  }
                }
              }
            })
            .catch(() => {});
        }
      } else {
        setAnswer2("");
        setOpenPleaseLogin(true);
      }
    }
  }

  const handleOpen = (teamUrl) => {
    if (!fixtureUrl && !teamUrl) return;

    let url = "";

    let currentDate = Moment.utc()
      .utcOffset(teamImage.timeOffset)
      .format("YYYY-MM-DDTHH:mm:ss");

    if (time > new Date(currentDate).getTime()) url = teamUrl;
    else url = fixtureUrl || teamUrl;

    if (!!url) window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="predictionBox">
      <div className="predictionBox-grid">
        <div className="predictionBox-item">
          <div className="predictionBox-itemWrapper">
            <div className="predictionBox-topSection">
              <div className="predictionBox-top-part1">
                <div className="predictionBox-groupTime-wrapper">
                  {/* <h6 className="matchText">M1</h6>
                    <h6 className="timeText">9:30 PM</h6>
                    <h6 className="groupText">GROUP A</h6> */}
                  <h6 className="groupText">Qn No. {index}</h6>
                </div>
                <div className="predictionBox-points-wrapper">
                  <p className="predictionBox-points">
                    {prop.data.que_points} Points
                  </p>
                </div>
                {!prop.isPostponed &&  
(
                <div className="predictionBox-remainingTime-wrapper">
                  <div className="predictionBox-timeImg">
                    <img
                      className={
                        time >
                        new Date(
                          Date.parse(
                            Moment.utc()
                              .utcOffset(teamImage.timeOffset)
                              .format("YYYY-MM-DDTHH:mm:ss"),
                          ),
                        ).getTime()
                          ? "time-icon"
                          : "time-icon-selected"
                      }
                      src={TimeIcon}
                      alt=""
                    />
                    {/* <img className="time-icon-selected" src={TimeIcon} alt="" /> */}
                  </div>
                  <PredictionCountDown
                    timeString={prop.data.que_time_qatar_string}
                  />
                </div>)}
              </div>
              <div className="predictionBox-top-part2">
                <div className="predictionBox-questionWrapper">
                  <p className="predictionBox-question">
                    {localStorage.language == "en"
                      ? prop.data.question
                      : prop.data.que_malayalam}
                  </p>
                </div>
              </div>
            </div>
            <div className="predictionBox-bottomSection">
              <div className="row d-flex justify-content-center px-1 p-lg-0">
                <div className="col-2 d-flex justify-content-center px-1 px-lg-3">
                  <div
                    className={
                      fixtureUrl || prop.data.fixture.fix_team_a?.team_url
                        ? "predictionBox-teamOne"
                        : "predictionBox-inactive"
                    }
                    onClick={() =>
                      handleOpen(prop.data.fixture.fix_team_a?.team_url)
                    }
                  >
                    <img
                      src={imageUrl + prop.data.fixture.fix_team_a.team_flag}
                      alt="Team 1"
                    />
                  </div>
                </div>
                <div className="col-8 d-flex justify-content-center">
                  <div className="predictionBox-predictionWrapper">
                    {/* <p className="topText">Tap to predict</p> */}
                    {prop.type == 1 ? (
                      <div className="predictionBox-prediction-input">
                        <div className="predictionBox-inputBox-team-single">
                          <input
                            value={answer}
                            onClick={handleClick}
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            onChange={(e) => {
                              markAnswer(e.target.value);
                            }}
                          />
                        </div>
                        {/*<div className="predictionBox-input-seperator">*/}
                        {/*<button type="button" className="btn btn-primary" onClick={predictAnswer}>Go</button>*/}
                        {/*</div>*/}
                      </div>
                    ) : (
                      <div className="predictionBox-prediction-input">
                        <div className="predictBox-prediction-input-top">
                          <div className="predictionBox-inputBox-team1">
                            <input
                              value={answer1}
                              onClick={handleClick}
                              type="text"
                              inputMode="numeric"
                              pattern="[0-9]*"
                              onChange={(e) => markAnswer1(e.target.value)}
                            />
                          </div>
                          <div className="predictionBox-input-seperator">
                            <div className="element"></div>
                          </div>
                          <div className="predictionBox-inputBox-team2">
                            <input
                              value={answer2}
                              onClick={handleClick}
                              type="text"
                              inputMode="numeric"
                              pattern="[0-9]*"
                              onChange={(e) => markAnswer2(e.target.value)}
                            />
                          </div>
                        </div>

                        {/* <div className="predictionBox-inputBox-team1"></div> */}
                        {/* <div className="predictionBox-input-seperator">
                          <div className="element"></div>
                        </div> */}
                      </div>
                    )}

                    <p className="bottomText">
                      {(prop.type == 1 && prop.data.user_prediction) ||
                      userPrediction
                        ? "Your prediction : " + userPrediction
                        : prop.type == 2 && prop.data.user_prediction
                          ? " Your predicted " +
                            userPrediction +
                            " will be the score"
                          : timeFlag || prop.data.que_answer
                            ? "Oops! You missed this prediction "
                            : "Type Your Prediction"}
                    </p>
                  </div>
                </div>
                <div className="col-2 d-flex justify-content-center px-1 px-lg-3">
                  <div
                    className={
                      fixtureUrl || prop.data.fixture.fix_team_b?.team_url
                        ? "predictionBox-teamTwo"
                        : "predictionBox-inactive"
                    }
                    onClick={() =>
                      handleOpen(prop.data.fixture.fix_team_b?.team_url)
                    }
                  >
                    <img
                      src={imageUrl + prop.data.fixture.fix_team_b.team_flag}
                      alt="Team 2"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="predictionBox-questionShare-wrapper">
              <div className="share-icon">
                <img src={ShareAlt} alt="" />
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <div className="timeOverModal">
        <Dialog
          open={openTimeOut}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleTimeOutClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <div className="timeOverModal-wrapper">
            <div className="timeOverModal-header">
              <h2>Time Over !!!</h2>
            </div>
            <div className="timeOverModal-content">
              <p>You can't change the prediction.</p>
              {/*<p>You cant the change the prediction now.</p>*/}
              {/*<p>You cant the change the prediction now.</p>*/}
            </div>

            <div className="timeOverModal-button-wrapper">
              <Button
                onClick={handleTimeOutClose}
                className="timeOverModal-login-btn"
              >
                GOT IT
              </Button>
            </div>
          </div>
        </Dialog>
      </div>
      <div className="pleaseLoginModal">
        {/* <Button variant="outlined" onClick={handleClickOpen}>
          PLEASE LOG IN
        </Button> */}
        <Dialog
          open={openPleaseLogin}
          TransitionComponent={Transition}
          keepMounted
          onClose={handlePleaseLoginClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <div className="pleaseLoginModal-wrapper">
            <div className="pleaseLoginModal-header">
              <h2>Not Logged In!</h2>
            </div>
            <div className="pleaseLoginModal-content">
              <p>Please login/register to start predicting.</p>
            </div>

            <div className="pleaseLoginModal-button-wrapper">
              <Link to="/mobile-login">
                <Button className="pleaseLoginModal-login-btn">LOGIN</Button>
              </Link>
              <Link to="/mobile-register">
                <Button className="pleaseLoginModal-register-btn">
                  REGISTER
                </Button>
              </Link>
            </div>
          </div>
        </Dialog>
      </div>
    </div>
  );
};

export default PredictionBoxInput;
